import { IonBadge, IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonReorder, IonReorderGroup, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, isPlatform, ItemReorderEventDetail, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { add, arrowBack, pencil, reorderTwo, trash } from 'ionicons/icons';
import * as Leaflet from 'leaflet';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import { alterarTipoConfiguracoesEntregaEmpresa, empresaConfiguracoesAlterar, onboardingAtualizarEtapa, ordernarItemConfiguracoesEntregaEmpresa, removerConfiguracoesEntregaEmpresa, requestService } from '../../../../../Utils/Services';
import "./ConfiguracoesEntrega.css";

type Props = {
  onDismiss: () => void;
};

const ConfiguracoesEntrega: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaConfiguracoesEntrega, setListaConfiguracoesEntrega] = useState<any>([]);

  const [showModalRaio, setShowModalRaio] = useState(false);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [index, setIndex] = useState("");
  const [nome, setNome] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const isWeb = isPlatform('desktop');
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [isDisabled, setIsDisabled] = useState(true);

  const inputRef = useRef<any>(null);
  const [tipo, setConfiguracoesEntrega] = useState('');

  const [idConfiguracaoEndereco, setIdConfiguracaoEndereco] = useState<any>();
  const [raio, setRaio] = useState<any>();
  const [tempoRaio, setTempoRaio] = useState<any>();
  const [taxaRaio, setTaxaRaio] = useState<any>();


  const [mostartAlerta] = useIonAlert();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);


  const [raioSelecionado, setRaioSelecionado] = useState<number | null>(null);
  const mapaRef = useRef<Leaflet.Map | null>(null);
  const circulosRef = useRef<Leaflet.Circle[]>([]);

  // Estados para o novo comportamento
  const [tipoConfiguracao, setTipoConfiguracao] = useState<'bairro' | 'raio' | ''>('');
  const [nomeBairro, setNomeBairro] = useState('');
  const [valorBairro, setValorBairro] = useState('');
  const [tempoBairro, setTempoBairro] = useState('');
  const [showModalBairro, setShowModalBairro] = useState(false);

  const myIcon = new Leaflet.Icon({
    iconUrl: '/assets/pin.svg',
    iconSize: [30, 30],
    popupAnchor: [0, -20]
  });

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    console.log('dadosEmpresa.tipoConfiguracoesEntrega', dadosEmpresa.tipoConfiguracoesEntrega);
    setListaConfiguracoesEntrega(dadosEmpresa.configuracoesEntrega || []);
    setTipoConfiguracao(dadosEmpresa.tipoConfiguracoesEntrega || '');
  });

  useEffect(() => {
    if (showModalRaio) {
      setTimeout(() => {
        const container = document.getElementById('map');
        if (container) {
          loadMap();
        }
      }, 500);
    }
  }, [showModalRaio]);

  useEffect(() => {
    setTimeout(() => {
      const container = document.getElementById('map');
      if (container) {
        loadMap();
      }
    }, 500);
  }, [raioSelecionado]);

  function haversine(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Raio da Terra em km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distância em km
  }

  function loadMap() {
    try {
      if (mapaRef.current) {
        mapaRef.current.off();  // Remove todos os eventos associados ao mapa
        mapaRef.current.remove();  // Remove a instância do mapa
        mapaRef.current = null;  // Zera a referência para evitar reutilização
      }

      const container = document.getElementById('map');
      if (container) {
        container.innerHTML = ""; // Limpa o contêiner antes de recriar o mapa
      }

      const mapa = Leaflet.map('map').setView(
        [Number(dadosEmpresa.empresaLatitude), Number(dadosEmpresa.empresaLongitude)],
        12
      );

      mapaRef.current = mapa;

      Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© OpenStreetMap'
      }).addTo(mapa);

      const localizacao = Leaflet.latLng(
        Number(dadosEmpresa.empresaLatitude),
        Number(dadosEmpresa.empresaLongitude)
      );

      Leaflet.marker(localizacao, { icon: myIcon }).addTo(mapa);

      let raios = [0.5, 1, 1.5, 2, 2.5, 3, 4, 5, 8, 12];
      let cores = [
        '#b71c1c', // Vermelho escuro (0.5km)
        '#d32f2f', // Vermelho (1km)
        '#f44336', // Vermelho claro (1.5km)
        '#ff5722', // Laranja avermelhado (2km)
        '#ff9800', // Laranja (2.5km)
        '#ffc107', // Amarelo/dourado (3km)
        '#4caf50', // Verde (4km)
        '#00bcd4', // Ciano (5km)
        '#2196f3', // Azul (8km)
        '#1565c0'  // Azul escuro (12km)
      ];

      circulosRef.current.forEach(circle => circle.remove());
      circulosRef.current = [];

      raios.forEach((raio, index) => {
        let circle = Leaflet.circle(localizacao, {
          color: cores[index],
          fillColor: cores[index],
          fillOpacity: raio === raioSelecionado ? 0.5 : 0.05,
          radius: raio * 1000
        }).addTo(mapa);

        circulosRef.current.push(circle);
      });

      mapa.on('click', (e: Leaflet.LeafletMouseEvent) => {
        const { lat, lng } = e.latlng;
        const distancia = haversine(lat, lng, localizacao.lat, localizacao.lng);

        let novoRaioSelecionado = null;

        if (distancia >= 8 && distancia <= 12) {
          novoRaioSelecionado = 12;
        } else {
          let menorDistancia = Infinity;

          raios.forEach(raio => {
            if (distancia <= raio) {
              const diferenca = Math.abs(distancia - raio);
              if (diferenca < menorDistancia) {
                menorDistancia = diferenca;
                novoRaioSelecionado = raio;
              }
            }
          });
        }

        console.log("Raio selecionado:", novoRaioSelecionado);
        setRaioSelecionado(novoRaioSelecionado);
        setRaio(novoRaioSelecionado?.toString());
      });

    } catch (e: any) {
      console.error("Erro ao carregar o mapa:", e.message);
    }
  }


  function deletarConfiguracoesEntrega(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delConfiguracoesEntrega = async () => {
      setShowLoading(true);
      try {
        const resp = await fetch(removerConfiguracoesEntregaEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
          {
            method: removerConfiguracoesEntregaEmpresa.method,
            headers: [
              ["token", token]
            ],
            body: JSON.stringify({ 'index': indice }),
            credentials: 'include'
          });
        const response = await resp.json();

        if (response) {
          setListaConfiguracoesEntrega(response.message.Attributes.configuracoesEntrega || []);
          dadosEmpresa.configuracoesEntrega = response.message.Attributes.configuracoesEntrega;
          setDadosEmpresa(dadosEmpresa);


          console.log("retorno", response);
          setTextToast("Configuração removida com sucesso.");
          setShowToast(true);
        }
        // carregarConta();
      } catch (err) {
        console.log(err);
        setTextToast("Ocorreu um erro ao remover.");
        setShowToast(true);
      } finally {
        setShowLoading(false);
      }
    }

    delConfiguracoesEntrega();

  }

  function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    // Before complete is called with the items they will remain in the
    // order before the drag
    //console.log('Before complete', listaItemCatalogoProdutos);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    setListaConfiguracoesEntrega(event.detail.complete(listaConfiguracoesEntrega));

    // After complete is called the items will be in the new order
    //console.log('After complete', listaItemCatalogoProdutos);


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const ordItemConfiguracoesEntrega = async () => {
      const resp = await fetch(ordernarItemConfiguracoesEntregaEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: ordernarItemConfiguracoesEntregaEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'configuracoesEntrega': listaConfiguracoesEntrega }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno ordenar", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Ordenação alterada com sucesso.");
        setShowToast(true);
        setListaConfiguracoesEntrega(retorno.Item?.Attributes?.configuracoesEntrega || []);
        dadosEmpresa.configuracoesEntrega = retorno.Item?.Attributes?.configuracoesEntrega;
        setDadosEmpresa(dadosEmpresa);

      }
      else {
        setTextToast("Ocorreu um erro ao ordernar.");
        setShowToast(true);
      }
    }

    ordItemConfiguracoesEntrega();

  }


  const loadConfiguracoesEntrega = () => {
    if (listaConfiguracoesEntrega == undefined) return;

    if (listaConfiguracoesEntrega.length === 0) {
      return (
        <IonItem lines="full" key={"semConfiguracao"}>
          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}>
              <strong>
                {tipoConfiguracao === 'bairro'
                  ? 'Nenhuma configuração de bairro cadastrada'
                  : 'Nenhuma configuração de raio cadastrada'
                }
              </strong>
            </h2>
          </IonLabel>
        </IonItem>
      );
    }

    return (
      <>
        <IonReorderGroup disabled={isDisabled} onIonItemReorder={handleReorder}>
          {listaConfiguracoesEntrega.map((value: any, index: any) => {
            return (
              <IonItem lines="full" key={index}>
                {/* Primeira coluna - Bairro/Raio */}
                <IonLabel style={{ fontSize: "12px" }}>
                  {value.tipo === 'bairro' ? value.bairro : value.raio}
                </IonLabel>

                {/* Segunda coluna - Tempo */}
                <IonLabel style={{ fontSize: "12px" }}>
                  {value.tempo}
                </IonLabel>

                {/* Terceira coluna - Taxa */}
                <IonLabel style={{ fontSize: "12px" }}>
                  R$ {value.taxa || '0,00'}
                </IonLabel>

                <IonLabel style={{ fontSize: "12px", maxWidth: "100px" }}></IonLabel>

                <div style={{ position: "absolute", right: "10px", zIndex: 9999999, backgroundColor: "#ffffff", textAlign: "right" }}>
                  <IonReorder slot="end"></IonReorder>
                </div>

                <div style={{ position: "absolute", right: "6px", zIndex: 9999999, backgroundColor: "#ffffff", textAlign: "right" }}>
                  <IonButtons>
                    <IonButton hidden={!isDisabled || acessos?.configuracoes != 'edicao'}
                      onClick={() => {
                        if (value.tipo === 'bairro') {
                          setIndex(index.toString());
                          setNomeBairro(value.bairro || '');
                          setValorBairro(value.taxa || '');
                          setTempoBairro(value.tempo || '');
                          setShowModalBairro(true);
                        } else {
                          setIndex(index);
                          setIdConfiguracaoEndereco(value.id);
                          setRaio(value.raio);
                          setRaioSelecionado(Number(value.raio));
                          setTempoRaio(value.tempo);
                          setTaxaRaio(value.taxa);
                          setShowModalRaio(true);
                        }
                      }}>
                      <IonIcon color="primary" icon={pencil} />
                    </IonButton>

                    <IonButton hidden={!isDisabled || acessos?.configuracoes != 'edicao'}
                      onClick={() => {
                        mostartAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarConfiguracoesEntrega(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        })
                      }}>
                      <IonIcon color="primary" icon={trash} />
                    </IonButton>
                  </IonButtons>
                </div>
              </IonItem>
            )
          })}
        </IonReorderGroup>
      </>
    );
  }


  const validateRaio = () => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];

    if (!raio) {
      isValid = false;
      errors.push({ message: `Raio não pode estar vazio.` });
    }

    if (!tempoRaio) {
      isValid = false;
      errors.push({ message: `Tempo não pode estar vazio.` });
    }

    if (!taxaRaio) {
      isValid = false;
      errors.push({ message: `Taxa não pode estar vazio.` });
    }



    return { isValid, errors };
  };


  async function salvarRaio() {

    const { isValid, errors } = validateRaio();

    if (!isValid && errors.length > 0) {
      console.log('Erros de validação:', errors);

      // Mapeia o array de erros e retorna um array de strings para o IonToast
      const errorMessages: any = errors.map((error) => `${error.message}`);
      setTextToast(errorMessages.join('<br>'));
      setShowToast(true);
      return;
    }

    const objectRequest = {
      index: index,
      configuracoesEntrega: {
        tipo: 'raio',
        raio: raio,
        taxa: taxaRaio,
        tempo: tempoRaio
      }
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    setShowLoading(true);

    await requestService(
      empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?configuracoesentrega=sim"),
      {
        method: empresaConfiguracoesAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          console.log("response", response);

          setListaConfiguracoesEntrega(response.message.Attributes.configuracoesEntrega || []);
          dadosEmpresa.configuracoesEntrega = response.message.Attributes.configuracoesEntrega;
          setDadosEmpresa(dadosEmpresa);

          // Marcar etapa do onboarding como concluída
          if (onboardingData && !onboardingData.onboarding_concluido) {
            const urlOnb = onboardingAtualizarEtapa.url
              .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
            requestService(urlOnb, {
              method: onboardingAtualizarEtapa.method,
              body: JSON.stringify({ etapa_id: 'configuracao_entrega', status: 'concluido' }),
              headers: [["token", window.localStorage.getItem("token")]],
              credentials: 'include'
            }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
          }

          //carregarConta();
          setShowModalRaio(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro.");
        setShowToast(true);
        setShowLoading(false);
      })


  }

  const generateTimeOptions5Min = () => {
    const times = [];
    for (let minute = 10; minute <= 90; minute += 5) {
      const minuteStr = minute < 10 ? `0${minute}` : `${minute}`;
      times.push(`${minuteStr}`);
    }
    return times;
  };

  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    // Se for 0 horas, retorna apenas os minutos
    if (hours === 0 && mins > 0) {
      return `${mins} minutos`;
    }

    // Se for 0 minutos, retorna apenas as horas
    if (mins === 0 && hours > 0) {
      return `${hours} horas`;
    }

    // Se ambos forem diferentes de 0, retorna as horas e minutos
    return `${hours} horas e ${mins} minutos`;
  };

  const onChangeValorRaio = (e: any) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");


    setTaxaRaio(v);

  };

  const alterarTipoConfiguracao = async (novoTipo: 'bairro' | 'raio') => {
    try {
      setShowLoading(true);

      const objectRequest = {
        tipoConfiguracao: novoTipo
      };

      await requestService(
        alterarTipoConfiguracoesEntregaEmpresa.url.replace("{id}", loja.replaceAll("#", "%23")),
        {
          method: alterarTipoConfiguracoesEntregaEmpresa.method,
          body: JSON.stringify(objectRequest),
          headers: [
            ["token", window.localStorage.getItem("token")]
          ],
          credentials: 'include'
        },
        history,
        (response: any) => {

          if (response && response.Item) {
            setListaConfiguracoesEntrega(response.Item.Attributes.configuracoesEntrega || []);

            // Cria um novo objeto para garantir que o React detecte a mudança
            const novosDadosEmpresa = {
              ...dadosEmpresa,
              tipoConfiguracoesEntrega: response.Item.Attributes.tipoConfiguracoesEntrega,
              configuracoesEntrega: response.Item.Attributes.configuracoesEntrega || []
            };

            console.log('Atualizando dadosEmpresa com:', novosDadosEmpresa);
            setDadosEmpresa(novosDadosEmpresa);

            // Atualiza o tipo de configuração
            setTipoConfiguracao(novoTipo);

            setTextToast('Tipo de configuração alterado com sucesso!');
            setShowToast(true);
          }
        },
        (error: any) => {
          console.error('Erro ao alterar tipo de configuração:', error);
          setTextToast('Erro ao alterar tipo de configuração.');
          setShowToast(true);
        }
      );
    } catch (error) {
      console.error('Erro ao alterar tipo de configuração:', error);
      setTextToast('Erro ao alterar tipo de configuração.');
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  };

  const onChangeValorBairro = (e: any) => {
    e.preventDefault();

    let v = e.detail.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValorBairro(v);
  };

  const validateBairro = () => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];

    if (!nomeBairro) {
      isValid = false;
      errors.push({ message: `Nome do bairro não pode estar vazio.` });
    }

    if (!tempoBairro) {
      isValid = false;
      errors.push({ message: `Tempo não pode estar vazio.` });
    }

    if (!valorBairro) {
      isValid = false;
      errors.push({ message: `Taxa não pode estar vazia.` });
    }

    return { isValid, errors };
  };

  async function salvarBairro() {
    const { isValid, errors } = validateBairro();

    if (!isValid && errors.length > 0) {
      console.log('Erros de validação:', errors);

      // Mapeia o array de erros e retorna um array de strings para o IonToast
      const errorMessages: any = errors.map((error) => `${error.message}`);
      setTextToast(errorMessages.join('<br>'));
      setShowToast(true);
      return;
    }

    const objectRequest = {
      index: index,
      configuracoesEntrega: {
        tipo: 'bairro',
        bairro: nomeBairro,
        taxa: valorBairro,
        tempo: tempoBairro
      }
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    setShowLoading(true);

    await requestService(
      empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?configuracoesentrega=sim"),
      {
        method: empresaConfiguracoesAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          console.log("response", response);

          setListaConfiguracoesEntrega(response.message.Attributes.configuracoesEntrega || []);
          dadosEmpresa.configuracoesEntrega = response.message.Attributes.configuracoesEntrega;
          setDadosEmpresa(dadosEmpresa);

          // Marcar etapa do onboarding como concluída
          if (onboardingData && !onboardingData.onboarding_concluido) {
            const urlOnb = onboardingAtualizarEtapa.url
              .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
            requestService(urlOnb, {
              method: onboardingAtualizarEtapa.method,
              body: JSON.stringify({ etapa_id: 'configuracao_entrega', status: 'concluido' }),
              headers: [["token", window.localStorage.getItem("token")]],
              credentials: 'include'
            }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
          }

          //carregarConta();
          setShowModalBairro(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro.");
        setShowToast(true);
        setShowLoading(false);
      })
  }

  return (

    <IonPage className="Tipo">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Configuração de entrega</IonTitle>
        </IonToolbar>
        <OnboardingContextBanner />
        {isWeb && (
          <IonToolbar hidden={acessos?.configuracoes != 'edicao'}>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "8px 8px 0 8px" }}>
              <IonButton
                fill="solid"
                size="large"
                color="tertiary"
                onClick={() => {
                  if (tipoConfiguracao === 'bairro') {
                    setNomeBairro('');
                    setValorBairro('');
                    setTempoBairro('');
                    setIndex('');
                    setShowModalBairro(true);
                  } else {
                    setIndex("");
                    setIdConfiguracaoEndereco("");
                    setRaio("");
                    setRaioSelecionado(null);
                    setTempoRaio("");
                    setTaxaRaio("");
                    setShowModalRaio(true);
                  }
                }}>
                <IonIcon slot="start" icon={add} />
                Nova configuração
              </IonButton>
            </div>
          </IonToolbar>
        )}
      </IonHeader>
      <IonContent fullscreen={false}>

        {/* Subtítulo */}
        <div style={{ padding: '16px', textAlign: 'left' }}>
          <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#666' }}>
            Adicione pelo menos uma região de atendimento do seu estabelecimento
          </p>
        </div>

        {/* Seleção de tipo de configuração */}
        <div style={{ padding: '0 16px 16px 16px' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <IonButton
              fill={tipoConfiguracao === 'bairro' ? 'solid' : 'outline'}
              color={tipoConfiguracao === 'bairro' ? 'primary' : 'medium'}
              onClick={() => {
                // Se já está no tipo 'bairro', não faz nada
                if (tipoConfiguracao === 'bairro') {
                  return;
                }

                if (listaConfiguracoesEntrega.length > 0) {
                  mostartAlerta({
                    backdropDismiss: false,
                    header: 'Alterar modo de cadastro de taxas de entrega',
                    message: 'Ao alterar o modo de cadastro de taxas de entrega, os cadastros já existentes serão excluídos. Deseja continuar ?',
                    buttons: [
                      {
                        text: 'Cancelar',
                        role: 'cancel',
                      },
                      {
                        text: 'Confirmar',
                        cssClass: 'primary',
                        handler: () => {
                          alterarTipoConfiguracao('bairro');
                        }
                      }
                    ],
                    onDidDismiss: (e) => console.log('did dismiss'),
                  });
                } else {
                  alterarTipoConfiguracao('bairro');
                }
              }}
              style={{ flex: 1 }}
            >
              Bairro
            </IonButton>
            <IonButton
              fill={tipoConfiguracao === 'raio' ? 'solid' : 'outline'}
              color={tipoConfiguracao === 'raio' ? 'primary' : 'medium'}
              onClick={() => {
                // Se já está no tipo 'raio', não faz nada
                if (tipoConfiguracao === 'raio') {
                  return;
                }

                if (listaConfiguracoesEntrega.length > 0) {
                  mostartAlerta({
                    backdropDismiss: false,
                    header: 'Alterar modo de cadastro de taxas de entrega',
                    message: 'Ao alterar o modo de cadastro de taxas de entrega, os cadastros já existentes serão excluídos. Deseja continuar ?',
                    buttons: [
                      {
                        text: 'Cancelar',
                        role: 'cancel',
                      },
                      {
                        text: 'Confirmar',
                        cssClass: 'primary',
                        handler: () => {
                          alterarTipoConfiguracao('raio');
                        }
                      }
                    ],
                    onDidDismiss: (e) => console.log('did dismiss'),
                  });
                } else {
                  alterarTipoConfiguracao('raio');
                }
              }}
              style={{ flex: 1 }}
            >
              Raio
            </IonButton>
          </div>
        </div>

        {/* Mostrar conteúdo apenas se tipoConfiguracao for 'bairro' ou 'raio' */}
        {(tipoConfiguracao === 'bairro' || tipoConfiguracao === 'raio') && (
          <>
            {/* Cabeçalho da tabela - sempre visível */}
            <IonToolbar>
              <IonList>
                <IonItem lines="none" style={{ fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>
                  <IonLabel style={{ fontSize: "12px" }}>
                    {tipoConfiguracao === 'bairro' ? 'Bairro' : 'Raio'}
                  </IonLabel>
                  <IonLabel style={{ fontSize: "12px" }}>Tempo(minutos)</IonLabel>
                  <IonLabel style={{ fontSize: "12px" }}>Taxa(R$)</IonLabel>

                  <IonLabel style={{ textAlign: "right", maxWidth: "100px" }}>
                    <IonBadge hidden={acessos?.configuracoes != 'edicao'}
                      onClick={() => setIsDisabled((current) => !current)}>
                      <IonIcon color="medium" icon={reorderTwo}></IonIcon>
                    </IonBadge>
                  </IonLabel>
                </IonItem>
              </IonList>
            </IonToolbar>

            {/* Lista de configurações */}
            <IonList>
              {loadConfiguracoesEntrega()}
            </IonList>

            {/* Botão flutuante para adicionar */}
            {!isWeb && (
              <IonFab vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao'}>
                <IonFabButton color="tertiary" class="custom-fab-button" onClick={() => {
                  if (tipoConfiguracao === 'bairro') {
                    setNomeBairro('');
                    setValorBairro('');
                    setTempoBairro('');
                    setIndex('');
                    setShowModalBairro(true);
                  } else {
                    setIndex("");
                    setIdConfiguracaoEndereco("");
                    setRaio("");
                    setRaioSelecionado(null);
                    setTempoRaio("");
                    setTaxaRaio("");
                    setShowModalRaio(true);
                  }
                }} >
                  <IonIcon color="light" icon={add}></IonIcon>
                </IonFabButton>
              </IonFab>
            )}
          </>
        )}

        <IonModal className="fullscreen-modal" onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showModalRaio} onDidDismiss={() => {
          setShowModalRaio(false);
          setIndex("");
          setIdConfiguracaoEndereco("");
          setRaio("");
          setRaioSelecionado(null);
          setTempoRaio("");
          setTaxaRaio("");
        }}>


          <>
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalRaio(false)} />
                </IonButtons>
                <IonTitle>{index !== "" ? 'Editar Raio' : 'Novo Raio'}</IonTitle>
              </IonToolbar>
              <IonGrid>

                <IonRow>
                  <IonCol>
                    <IonList>
                      <IonItem>
                        <IonLabel position="stacked">KM*</IonLabel>
                        <IonSelect
                          value={raio}
                          placeholder="Selecione um raio"
                          onIonChange={(e) => { setRaio(e.detail.value); setRaioSelecionado(Number(e.detail.value)); }}
                        >
                          <IonSelectOption value="0.5">500m</IonSelectOption>
                          <IonSelectOption value="1">1km</IonSelectOption>
                          <IonSelectOption value="1.5">1,5km</IonSelectOption>
                          <IonSelectOption value="2">2km</IonSelectOption>
                          <IonSelectOption value="2.5">2,5km</IonSelectOption>
                          <IonSelectOption value="3">3km</IonSelectOption>
                          <IonSelectOption value="4">4km</IonSelectOption>
                          <IonSelectOption value="5">5km</IonSelectOption>
                          <IonSelectOption value="8">8km</IonSelectOption>
                          <IonSelectOption value="12">12km</IonSelectOption>
                        </IonSelect>
                      </IonItem>


                      <IonItem>
                        <IonLabel position="stacked">Tempo de entrega*</IonLabel>
                        <IonSelect
                          value={tempoRaio}
                          placeholder="Selecione o tempo"
                          onIonChange={(e) => setTempoRaio(e.detail.value)}
                        >
                          {generateTimeOptions5Min().map((time: any, index: any) => (
                            <IonSelectOption key={index} value={time}>
                              {time} minutos
                            </IonSelectOption>
                          ))}
                        </IonSelect>
                      </IonItem>

                      <IonItem>
                        <IonLabel position="stacked">Taxa*</IonLabel>

                        <IonInput
                          clearInput={true}
                          type="tel"
                          maxlength={14}
                          placeholder="Valor"
                          value={taxaRaio || ''}
                          onIonChange={(e: any) => onChangeValorRaio(e)}
                        />


                      </IonItem>


                    </IonList>
                  </IonCol>
                </IonRow>






              </IonGrid>
            </IonHeader>
            <IonContent className={"Mapa"}>



              <div style={{ position: "relative", width: "100%", height: "100%" }}>
                <div id="map" style={{ width: "100%", height: "100%" }}></div>
              </div>






            </IonContent>

            <IonFooter className="ion-no-border">
              <IonToolbar>
                <IonButton onClick={() => salvarRaio()} expand="block" type="submit">Salvar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>

        {/* Modal para cadastro de bairro */}
        <IonModal onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showModalBairro} onDidDismiss={() => {
          setShowModalBairro(false);
          setNomeBairro('');
          setTempoBairro('');
          setValorBairro('');
          setIndex('');
        }}>
          <>
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalBairro(false)} />
                </IonButtons>
                <IonTitle>{index !== "" ? 'Editar Bairro' : 'Novo Bairro'}</IonTitle>
              </IonToolbar>

            </IonHeader>


            <IonContent>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonList>
                      <IonItem>
                        <IonLabel position="stacked">Nome do Bairro*</IonLabel>
                        <IonInput
                          ref={inputRef}
                          clearInput={true}
                          type="text"
                          placeholder="Digite o nome do bairro"
                          value={nomeBairro || ''}
                          onIonChange={(e: any) => setNomeBairro(e.detail.value)}
                        />
                      </IonItem>

                      <IonItem>
                        <IonLabel position="stacked">Tempo de entrega*</IonLabel>
                        <IonSelect
                          value={tempoBairro}
                          placeholder="Selecione o tempo"
                          onIonChange={(e) => setTempoBairro(e.detail.value)}
                        >
                          {generateTimeOptions5Min().map((time: any, index: any) => (
                            <IonSelectOption key={index} value={time}>
                              {time} minutos
                            </IonSelectOption>
                          ))}
                        </IonSelect>
                      </IonItem>

                      <IonItem>
                        <IonLabel position="stacked">Taxa*</IonLabel>
                        <IonInput
                          clearInput={true}
                          type="tel"
                          maxlength={14}
                          placeholder="Valor"
                          value={valorBairro || ''}
                          onIonChange={(e: any) => onChangeValorBairro(e)}
                        />
                      </IonItem>
                    </IonList>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonContent>
            <IonFooter className="ion-no-border">
              <IonToolbar>
                <IonButton onClick={() => salvarBairro()} expand="block" type="submit">Salvar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default ConfiguracoesEntrega;